import { Box, Pagination } from "@mui/material";
import { useSearchParams } from "react-router-dom";

const ServicesPagination = ({ totalPages }: { totalPages: number }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const page = Number(searchParams.get("page") || "1");

  const handleChange = (_: any, newPage: number) => {
    setSearchParams({ page: newPage.toString() });
  };

  return (
    <Pagination
      page={page}
      count={totalPages}
      onChange={handleChange}
      sx={{
        direction: "ltr !important",
        margin: "0 auto",
        "& .MuiButtonBase-root": {
          borderRadius: "8px !important",
        },
      }}
    />
  );
};

export default ServicesPagination;
